import { Bounce, toast } from "react-toastify";
import axios from "axios";
import { email_regex, waitlist_url, popuptype_status } from "./Constants_Var";
import { useState } from "react";

export const waitlist = async (email, setEmail, status, message) => {
  if (email_regex.test(email)) {
    const response = await axios.post(waitlist_url, {
      status: status,
      email: email,
      message: message ? message : "",
    });

    if (response.status === 201 || response.status === 200) {
      setEmail("");
      toast_popup(
        "You have been added to our Waitlist",
        popuptype_status.success
      );

      return true;
    } else {
      toast_popup(
        "An Error Occoured while sending your Email,please try again Later",
        popuptype_status.error
      );
    }
  } else if (email === "") {
    toast_popup("Please enter your email", popuptype_status.error);
  } else {
    toast_popup("Verify your email", popuptype_status.error);
  }

  return false;
};


// FAQ function
export const useFAQ = () => {
  const [activeIndex, setActiveIndex] = useState(null);

  const toggleFAQ = (index) => {
    setActiveIndex(activeIndex === index ? null : index);
  };

  return { activeIndex, toggleFAQ };
};


export const toast_popup = (
  text,
  popup_type,
  position,
  autoClose,
  hideProgressBar,
  closeOnClick,
  pauseOnHover,
  draggable,
  progress,
  theme,
  transition
) => {
  toast[popup_type](text, {
    position: position ? position : "top-center",
    autoClose: autoClose ? autoClose : 5000,
    hideProgressBar: hideProgressBar ? hideProgressBar : false,
    closeOnClick: closeOnClick ? closeOnClick : false,
    pauseOnHover: pauseOnHover ? pauseOnHover : true,
    draggable: draggable ? draggable : true,
    progress: progress ? progress : undefined,
    theme: theme ? theme : "light",
    transition: transition ? transition : Bounce,
  });
};
